import {make} from "vuex-pathify"

const state = {
    isLoading: false,
    languages: [],
    form: {
        name: null,
        name_locale: [],
        code: null
    },
    page: [],
}

const mutations = make.mutations(state)

const actions = {
    loading({commit}) {
        commit('SET_IS_LOADING', true)
    },
    loaded({commit}) {
        commit('SET_IS_LOADING', false)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
